// frontend/src/components/FinanceReport/Accounting/our_allocations/requests.js
import { authFetch } from "../../../api/api";


const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");
const OUR_ALLOCATIONS_URL = `${BASE_URL}/api/accounting/our-allocations/`;
const CURRENCIES_URL = `${BASE_URL}/api/accounting/currencies/`;
// ----------------------------------------------------------------------
// 1. GET — список всех our_allocations
// ----------------------------------------------------------------------
export async function getAllOurAllocations() {
  const response = await authFetch(OUR_ALLOCATIONS_URL);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 2. GET — список с фильтром по родительскому allocation
// ----------------------------------------------------------------------
export async function getAllOurAllocationsById(allocationId) {
  const url = `${OUR_ALLOCATIONS_URL}?allocation=${allocationId}`;
  const response = await authFetch(url);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 3. GET — один объект по id
// ----------------------------------------------------------------------
export async function getOneOurAllocationById(id) {
  const response = await authFetch(`${OUR_ALLOCATIONS_URL}${id}/`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 4. POST — создать
// ----------------------------------------------------------------------
export async function postOurAllocation(payload) {
  const response = await authFetch(OUR_ALLOCATIONS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 5. PATCH — частично обновить
// ----------------------------------------------------------------------
export async function patchOurAllocation(id, patch) {
  const response = await authFetch(`${OUR_ALLOCATIONS_URL}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 6. PUT — полностью заменить
// ----------------------------------------------------------------------
export async function putOurAllocation(id, payload) {
  const response = await authFetch(`${OUR_ALLOCATIONS_URL}${id}/`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 7. DELETE — удалить
// ----------------------------------------------------------------------
export async function deleteOurAllocation(id) {
  const response = await authFetch(`${OUR_ALLOCATIONS_URL}${id}/`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return { ok: true, status: response.status };
}

// ----------------------------------------------------------------------
// 8. GET — заказы для выпадающего списка
// ----------------------------------------------------------------------
export async function getAllOrders() {
  const url = `${BASE_URL}/api/orders/`;
  const response = await authFetch(url);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();

  // На случай, если бэк вернёт пагинированный ответ
  if (Array.isArray(data)) return data;
  return data.results || [];
}




// ----------------------------------------------------------------------
// 9. Документы our_allocation — загрузка
// ----------------------------------------------------------------------
export async function uploadOurAllocationDocument(ourAllocationId, file) {
  const fd = new FormData();
  fd.append("files", file);

  const response = await authFetch(
    `${OUR_ALLOCATIONS_URL}${ourAllocationId}/documents/`,
    {
      method: "POST",
      body: fd,
      // Content-Type НЕ ставим — браузер сам поставит multipart с boundary
    }
  );

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }

  return response.json();
}

// ----------------------------------------------------------------------
// 10. Документы our_allocation — удаление
// ----------------------------------------------------------------------
export async function deleteOurAllocationDocument(documentId) {
  const response = await authFetch(
    `${BASE_URL}/api/accounting/our-allocation-documents/${documentId}/`,
    { method: "DELETE" }
  );

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return { ok: true, status: response.status };
}


// ----------------------------------------------------------------------
// 11. Валюты (справочник)
// ----------------------------------------------------------------------
export async function getAllCurrencies() {
  const response = await authFetch(CURRENCIES_URL);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}